/**
 * Where a generated (synthetic) calendar event opens. Both the Calendar page
 * and the supplier profile's Calendar tab dispatch on these id prefixes.
 */

/** Audit Lite: an open corrective action, id `audit_action:<action id>`. */
export const AUDIT_ACTION_PREFIX = 'audit_action:';

/**
 * Questionnaires › Audits › Actions with the action highlighted.
 *
 * @param eventId - the synthetic event id (`audit_action:<id>`)
 * @returns the Actions view, carrying the id only when it is numeric (never raw text in the query)
 */
export function auditActionPath(eventId: string): string {
  const actionId = eventId.startsWith(AUDIT_ACTION_PREFIX) ? eventId.slice(AUDIT_ACTION_PREFIX.length) : '';
  const base = '/questionnaires?tab=audits&view=actions';
  return /^\d+$/.test(actionId) ? `${base}&action=${actionId}` : base;
}
